import { Selectable } from '@shared/filters/selections'
import RefineWithAIButton from '@shared/refinement/RefineWithAIButton'
import stripHtml from '@shared/utils/stripHtml'
import { useFormContext, useWatch } from 'react-hook-form'
import useAwardMessageRefinement, {
  AwardMessageRefinementFormData,
} from './useAwardMessageRefinement'

type RefineAwardMessageButtonProps = {
  tenantQualities: Selectable[]
}

const RefineAwardMessageButton: React.FC<RefineAwardMessageButtonProps> = ({ tenantQualities }) => {
  const {
    refineMessage,
    deleteRefinementMessage,
    hasRefined,
    isPendingRefineMessage,
    isPendingUndoRefinedMessage,
  } = useAwardMessageRefinement({ tenantQualities })
  const { control, clearErrors } = useFormContext<AwardMessageRefinementFormData>()
  const message = useWatch({ control, name: 'message' })

  return (
    <RefineWithAIButton
      isMessageEmpty={stripHtml(message).length === 0}
      hasRefined={hasRefined}
      isPendingRefineMessage={isPendingRefineMessage}
      isPendingUndoRefinedMessage={isPendingUndoRefinedMessage}
      onBeforeRefine={() => clearErrors('root')}
      onRefine={refineMessage}
      onUndo={deleteRefinementMessage}
      refineButtonId="refineAwardButton"
      undoButtonId="btnUndoRefineAward"
    />
  )
}

export default RefineAwardMessageButton
